import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { Reveal } from "./Reveal";
import { waLink, COMMUNITY_MESSAGE } from "@/config";

export default function Community() {
  return (
    <section className="py-20 sm:py-24 bg-ivory" data-testid="community-section">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="relative overflow-hidden rounded-[2.5rem] bg-gradient-to-br from-sagesurface to-cardbg border border-botanical/15 px-8 sm:px-14 py-14 text-center shadow-card">
            <div
              className="absolute inset-0 opacity-[0.05]"
              style={{ backgroundImage: "radial-gradient(circle at 80% 15%, #4F772D 0%, transparent 40%)" }}
            />
            <div className="relative">
              <div className="w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center mx-auto mb-6 shadow-card">
                <MessageCircle size={26} className="text-white" />
              </div>
              <h2 className="font-serif text-3xl sm:text-4xl text-forest text-balance">
                Want Simple Health Guidance Before You Start Coaching?
              </h2>
              <p className="mt-4 text-base text-inkmuted max-w-xl mx-auto leading-relaxed">
                Join the Aarogyam Bharat health community for practical wellness tips, healthy habits, nutrition
                education and upcoming free workshops.
              </p>
              <motion.a
                whileHover={{ scale: 1.04, y: -2 }}
                whileTap={{ scale: 0.97 }}
                href={waLink(COMMUNITY_MESSAGE)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="join-whatsapp-community-button"
                className="mt-8 inline-flex items-center gap-2.5 rounded-full bg-[#25D366] text-forest px-8 py-4 text-sm font-extrabold tracking-wide shadow-card hover:brightness-95 transition-all"
              >
                <MessageCircle size={17} /> JOIN OUR WHATSAPP COMMUNITY
              </motion.a>
              <p className="mt-4 text-xs text-inkmuted">
                The main step is always your free 1:1 Discovery Call — this is simply a gentle place to begin.
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
